/**
 * Station and bin count utilities for map pins (event inventory summary).
 * Used by EventInventory and can be reused for reports or other map-based inventory views.
 */

import type { MapPin, StationType } from '../schema';

export interface StationCount {
    station: StationType;
    count: number;
}

export interface BinCounts {
    black: number;
    blue: number;
    green: number;
    slimJim: number;
    compostBucket: number;
    all: number;
}

export function countStations(mapPins: MapPin[]): StationCount[] {
    const records: Record<string, StationCount> = {};

    for (const pin of mapPins) {
        const { stationType } = pin;
        if (stationType) {
            const id = stationType.id;
            if (id in records) {
                records[id].count += 1;
            } else {
                records[id] = { station: stationType, count: 1 };
            }
        }
    }

    const counts = Object.values(records);
    counts.sort((a, b) => a.station.order - b.station.order);
    return counts;
}

export function countBins(stationCounts: StationCount[]): BinCounts {
    let black = 0;
    let blue = 0;
    let green = 0;
    let slimJim = 0;
    let compostBucket = 0;

    for (const { station, count } of stationCounts) {
        black += count * station.black;
        blue += count * station.blue;
        green += count * station.green;
        slimJim += count * station.slimJim;
        compostBucket += count * station.compostBucket;
    }

    const all = black + blue + green + slimJim + compostBucket;

    return {
        black,
        blue,
        green,
        slimJim,
        compostBucket,
        all,
    };
}
